import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import { FormattedMessage } from '@divvy-web/i18n'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import { InviteCollaboratorsDrawer } from '@sputnik/components/InviteCollaborators'

const InviteCollaboratorsLink = () => {
  const { appId } = useParams()
  const [isShowing, setIsShowing] = useState(false)
  const toggle = () => setIsShowing((status) => !status)

  return (
    <>
      <div data-testid='invite-collaborators-link'>
        <TextLink
          isDark
          className='invite'
          dataTestId='invite-collaborators-link'
          size={TextLinkSizes.SMALL}
          onClick={toggle}
        >
          <FormattedMessage
            defaultMessage='Invite a collaborator'
            id='sputnik.FormPageWrapper__s8trko'
          />
        </TextLink>
      </div>
      <InviteCollaboratorsDrawer
        appId={appId ?? ''}
        isShowing={isShowing}
        onClose={() => setIsShowing(false)}
      />
    </>
  )
}

export default InviteCollaboratorsLink
